"use client";

import { useCallback } from "react";
import type { DeleteOriginsResponse } from "@/generated/fastapi";
import { useMeiliRefreshState } from "@/state/globalStore";

export default function useBacklogSearchSync() {
  const { incrementMeiliRefreshStamp } = useMeiliRefreshState();

  const refreshBacklogOrigins = useCallback(() => {
    incrementMeiliRefreshStamp("backlog_origins");
  }, [incrementMeiliRefreshStamp]);

  const refreshExtractMindstrings = useCallback(() => {
    incrementMeiliRefreshStamp("extract_mindstrings");
  }, [incrementMeiliRefreshStamp]);

  const syncBacklogOriginCreated = useCallback(() => {
    refreshBacklogOrigins();
  }, [refreshBacklogOrigins]);

  const syncBacklogOriginUpdated = useCallback(() => {
    refreshBacklogOrigins();
    refreshExtractMindstrings();
  }, [refreshBacklogOrigins, refreshExtractMindstrings]);

  const syncBacklogOriginDeleted = useCallback(
    (result?: DeleteOriginsResponse | null) => {
      if (!result || result.status === "no_content") {
        return;
      }

      refreshBacklogOrigins();
    },
    [refreshBacklogOrigins],
  );

  const syncExtractedThoughts = useCallback(() => {
    refreshBacklogOrigins();
    refreshExtractMindstrings();
  }, [refreshBacklogOrigins, refreshExtractMindstrings]);

  const syncSuggestedThoughtMutation = useCallback(() => {
    refreshExtractMindstrings();
  }, [refreshExtractMindstrings]);

  return {
    refreshBacklogOrigins,
    refreshExtractMindstrings,
    syncBacklogOriginCreated,
    syncBacklogOriginUpdated,
    syncBacklogOriginDeleted,
    syncExtractedThoughts,
    syncSuggestedThoughtMutation,
  };
}
